export default __webpack_public_path__ + "static/media/chillmusic.46d222e9.mp3";